export type FacetFieldSource = 'custom' | 'metadata'

export type FacetBase = {
  id: string
  source: FacetFieldSource
  key: string
  label: string
}

export type OptionFacet = FacetBase & {
  options: string[]
  counts?: Record<string, number>
}

export type SearchFacets = {
  priceBounds: { min: number; max: number } | null
  productTypeValues: string[]
  brandValues: string[]
  optionFacets: OptionFacet[]
  numericFacets: NumericFacet[]
}

export type NumericFacet = FacetBase & {
  min: number
  max: number
}

export type NumericFilterState = Record<string, { min: string; max: string }>
export type OptionFilterState = Record<string, string[]>
export type SearchSort = 'updated-desc' | 'name-asc' | 'name-desc' | 'price-asc' | 'price-desc'
export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100] as const
export type PageSize = (typeof PAGE_SIZE_OPTIONS)[number]
export const DEFAULT_PAGE_SIZE: PageSize = 15

export type SearchUrlState = {
  searchTerm: string
  page: number
  pageSize: PageSize
  selectedBrands: string[]
  selectedTypes: string[]
  priceRange: { min: string; max: string }
  numericFilters: NumericFilterState
  optionFilters: OptionFilterState
  sort: SearchSort
}
